export default function voyageFuelDataToJson(fuel) {
    return {
        cost: fuel.cost,
        ncv: fuel.ncv,
        tag: fuel.tag,
        type: fuel.type,
    };
}